
export const goals = {
  // Goals Page
  goalsPageTitle: 'Metas',
  goals: 'Mis Metas',
  rewards: 'Recompensas',
  analytics: 'Análisis',
  noGoals: 'No se encontraron metas',
  noGoalsYet: 'Aún no hay metas',
  addGoal: 'Añadir Meta',
  editGoal: 'Editar Meta',
  deleteGoal: 'Eliminar Meta',
  filterGoals: 'Filtrar Metas',
  clearFilters: 'Limpiar Filtros',
  searchGoals: 'Buscar metas...',
  total: 'Total',
  loading: 'Cargando...',
  status: 'Estado',
  
  // Goal Details
  goalDetails: 'Detalles de la Meta',
  overview: 'Resumen',
  progress: 'Progreso',
  viewDetails: 'Ver Detalles',
  duplicate: 'Duplicar Meta',
  close: 'Cerrar',
  
  // Goal Statuses
  todo: 'Por Hacer',
  inProgress: 'En Progreso',
  done: 'Completada',
  allStatuses: 'Todos los Estados',
  selectStatus: 'Seleccionar Estado',
  
  // Categories
  categories: 'Categorías',
  category: 'Categoría',
  addCategory: 'Añadir Categoría',
  editCategory: 'Editar Categoría',
  deleteCategory: 'Eliminar Categoría',
  categoryName: 'Nombre de la Categoría',
  categoryColor: 'Color de la Categoría',
  noCategoriesFound: 'No se encontraron categorías',
  selectCategory: 'Selecciona una categoría',
  createNewCategory: 'Crear Nueva Categoría',
  allCategories: 'Todas las Categorías',
  noCategory: 'Sin Categoría',
  
  // Goal Form
  goalTitle: 'Título',
  dueDate: 'Fecha Límite',
  dueDateFrom: 'Fecha Desde',
  dueDateTo: 'Fecha Hasta',
  resources: 'Recursos',
  knowledge: 'Conocimientos',
  contacts: 'Contactos',
  notes: 'Notas',
  cancel: 'Cancelar',
  addResource: 'Añadir Recurso',
  addKnowledge: 'Añadir Conocimiento',
  addContact: 'Añadir Contacto',
  selectDate: 'Seleccionar Fecha',
  selectDueDate: 'Seleccionar Fecha Límite',
  
  // Resources, Knowledge, Contacts
  noResources: 'Aún no hay recursos añadidos',
  noKnowledge: 'Aún no hay elementos de conocimiento añadidos',
  noContacts: 'Aún no hay contactos añadidos',
  addNotes: 'Añade notas aquí...',
  copy: 'Copia',
  
  // Notifications
  goalCreated: 'Meta creada exitosamente',
  goalUpdated: 'Meta actualizada exitosamente',
  goalDeleted: 'Meta eliminada exitosamente',
  categoryCreated: 'Categoría creada exitosamente',
  categoryUpdated: 'Categoría actualizada exitosamente',
  categoryDeleted: 'Categoría eliminada exitosamente',
  
  // Confirmations
  confirmDeleteGoal: '¿Estás seguro de que deseas eliminar esta meta?',
  confirmDeleteCategory: '¿Estás seguro de que deseas eliminar esta categoría?',
  
  // Validation
  titleRequired: 'El título es obligatorio',
  dueDateRequired: 'La fecha límite es obligatoria',
  dueDateInvalid: 'La fecha límite debe ser hoy o posterior',
  categoryNameRequired: 'El nombre de la categoría es obligatorio',
  categoryColorRequired: 'El color de la categoría es obligatorio',
  
  // Authentication
  authRequired: 'Autenticación Requerida',
  pleaseLoginToViewGoals: 'Inicia sesión para ver y administrar tus metas',
  
  // Additional properties
  save: 'Guardar',
};
